


import { createSlice } from "@reduxjs/toolkit";

const forgotPasswordJourneySlice = createSlice({
    name: 'forgotPasswordJourney',
    initialState: '',
    reducers: {
        updateForgotPasswordJourneyStep: (state, action): any => {
            const newState = action.payload
            return newState

        },
    },
});
export const { updateForgotPasswordJourneyStep } = forgotPasswordJourneySlice.actions;
export default forgotPasswordJourneySlice.reducer;